import { render, staticRenderFns } from "./NotionUp.vue?vue&type=template&id=2f213edc&"
import script from "./NotionUp.vue?vue&type=script&lang=js&"
export * from "./NotionUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports